"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = (0, _connectToWebChat.default)(function (_ref) {
  var renderMarkdown = _ref.renderMarkdown,
      styleSet = _ref.styleSet;
  return {
    renderMarkdown: renderMarkdown,
    styleSet: styleSet
  };
})(function (_ref2) {
  var _ref2$contentType = _ref2.contentType,
      contentType = _ref2$contentType === void 0 ? 'text/markdown' : _ref2$contentType,
      renderMarkdown = _ref2.renderMarkdown,
      styleSet = _ref2.styleSet,
      text = _ref2.text;
  return contentType === 'text/markdown' && renderMarkdown ? _react.default.createElement("div", {
    className: (0, _classnames.default)('markdown', styleSet.textContent + ''),
    dangerouslySetInnerHTML: {
      __html: renderMarkdown(text || '')
    }
  }) : (text || '').split('\n').map(function (line, index) {
    return _react.default.createElement("p", {
      className: (0, _classnames.default)('plain', styleSet.textContent + ''),
      key: index
    }, line.trim());
  });
});

exports.default = _default;